/* Bobolio – lasery w tle, pojawianie się sekcji, ruch zdjęcia w banerze */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Morze: im niżej, tym głębiej – ryby rosną, pojawiają się rafy ---------- */
  var FISH_COLORS = [
    ['#FFD23F', '#FF8A2B'], ['#FF6F59', '#FFD23F'], ['#FF8FC7', '#FFD1E8'], ['#7CF2D6', '#00B8C4'],
    ['#4FC3F7', '#FFFFFF'], ['#9B7BFF', '#FFD23F'], ['#2E6FD9', '#7FD3F7'], ['#1B3F7A', '#4FC3F7']
  ];
  function fishSVG(c1, c2, kind) {
    if (kind === 1) { /* ryba w paski (jak błazenek) */
      return '<svg viewBox="0 0 120 70"><path d="M100 35 L120 15 L116 35 L120 55 Z" fill="' + c1 + '"/><ellipse cx="58" cy="35" rx="46" ry="26" fill="' + c1 + '"/><path d="M40 11 Q46 35 40 59" stroke="#fff" stroke-width="8" fill="none"/><path d="M68 11 Q74 35 68 59" stroke="#fff" stroke-width="8" fill="none"/><path d="M48 9 Q60 0 74 10" fill="' + c2 + '"/><circle cx="26" cy="30" r="6" fill="#fff"/><circle cx="25" cy="30" r="3.2" fill="#0B3A6B"/></svg>';
    }
    if (kind === 2) { /* okrągła rybka */
      return '<svg viewBox="0 0 120 90"><path d="M92 45 L118 22 L112 45 L118 68 Z" fill="' + c2 + '"/><circle cx="52" cy="45" r="38" fill="' + c1 + '"/><path d="M40 10 Q58 -2 74 14" fill="' + c2 + '"/><path d="M42 80 Q58 92 72 78" fill="' + c2 + '"/><circle cx="34" cy="38" r="8" fill="#fff"/><circle cx="32" cy="38" r="4" fill="#0B3A6B"/><path d="M20 54 Q26 58 32 54" stroke="#0B3A6B" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
    }
    /* klasyczna rybka */
    return '<svg viewBox="0 0 120 64"><path d="M96 32 L120 12 L114 32 L120 52 Z" fill="' + c2 + '"/><ellipse cx="56" cy="32" rx="46" ry="22" fill="' + c1 + '"/><path d="M50 10 Q62 -2 76 12" fill="' + c2 + '"/><path d="M58 32 Q66 40 74 34" stroke="' + c2 + '" stroke-width="4" fill="none"/><circle cx="26" cy="28" r="6" fill="#fff"/><circle cx="25" cy="28" r="3" fill="#0B3A6B"/></svg>';
  }
  function coralSVG(kind, hue) {
    if (kind === 0) { /* rozgałęziony koralowiec */
      return '<svg viewBox="0 0 200 220"><g fill="none" stroke="' + hue + '" stroke-width="16" stroke-linecap="round"><path d="M100 220 V120"/><path d="M100 150 Q60 130 50 80"/><path d="M50 80 Q40 50 55 25"/><path d="M50 95 Q25 85 20 55"/><path d="M100 130 Q140 110 150 70"/><path d="M150 70 Q160 40 145 18"/><path d="M150 85 Q175 75 182 45"/><path d="M100 120 Q98 80 105 50"/></g></svg>';
    }
    if (kind === 1) { /* wodorosty */
      return '<svg viewBox="0 0 160 260"><g fill="none" stroke-linecap="round" stroke-width="12"><path d="M40 260 Q20 200 45 150 Q70 100 40 40" stroke="#2BB673"/><path d="M80 260 Q100 190 75 130 Q55 80 85 20" stroke="#1F9D63"/><path d="M120 260 Q140 210 118 160 Q100 120 128 70" stroke="#38C986"/></g></svg>';
    }
    /* koral-wachlarz + muszelki */
    return '<svg viewBox="0 0 220 180"><path d="M110 180 C40 170 10 120 30 70 C50 20 100 10 110 40 C120 10 170 20 190 70 C210 120 180 170 110 180Z" fill="' + hue + '"/><g stroke="rgba(255,255,255,.45)" stroke-width="4" fill="none"><path d="M110 175 L110 45"/><path d="M110 170 L50 80"/><path d="M110 170 L170 80"/><path d="M110 172 L30 120"/><path d="M110 172 L190 120"/></g><circle cx="40" cy="172" r="14" fill="#FFE3B3"/><circle cx="182" cy="170" r="11" fill="#FFC9D6"/></svg>';
  }
  function sea() {
    if (document.querySelector('.mk-sea')) return;
    var box = document.createElement('div');
    box.className = 'mk-sea';
    box.setAttribute('aria-hidden', 'true');
    document.body.prepend(box);
    var mobile = window.innerWidth < 750;

    function build() {
      box.innerHTML = '';
      var H = Math.max(document.documentElement.scrollHeight, window.innerHeight);
      box.style.height = H + 'px';
      var start = Math.min(700, H * 0.12);      /* od tego miejsca zaczyna się „woda” */
      var html = '';

      /* promienie światła przy powierzchni */
      for (var r = 0; r < (mobile ? 3 : 6); r++) {
        html += '<span class="mk-ray" style="top:' + start + 'px;left:' + (8 + r * 16) + '%;transform:rotate(' + (-18 + r * 7) + 'deg)"></span>';
      }

      /* ryby: im głębiej, tym większe i ciemniejsze */
      var count = Math.max(6, Math.round(H / (mobile ? 520 : 380)));
      for (var i = 0; i < count; i++) {
        var depth = i / count;                                   /* 0 = płytko, 1 = głęboko */
        var y = start + depth * (H - start - 200) + Math.random() * 160;
        var size = (mobile ? 0.6 : 1) * (26 + depth * depth * 190 + Math.random() * 22);
        var pal = FISH_COLORS[Math.min(FISH_COLORS.length - 1, Math.floor(depth * (FISH_COLORS.length - 2) + Math.random() * 2))];
        var left = Math.random() < 0.5;
        var t = (16 + Math.random() * 14 + depth * 14).toFixed(1);
        var d = (-Math.random() * t).toFixed(1);
        html += '<div class="mk-fish' + (left ? ' is-left' : '') + '" style="top:' + y.toFixed(0) + 'px;--s:' + size.toFixed(0) + 'px;--t:' + t + 's;--d:' + d + 's">' + fishSVG(pal[0], pal[1], i % 3) + '</div>';
      }

      /* rafa: coraz większe koralowce przy krawędziach, od ~30% głębokości */
      var hues = ['#FF6F59', '#FF8FC7', '#FFB347', '#9B7BFF', '#FF5A8A'];
      var step = mobile ? 900 : 650;
      for (var k = 0, yy = start + H * 0.22; yy < H - 150; yy += step, k++) {
        var dep = yy / H;
        var w = (mobile ? 0.55 : 1) * (110 + dep * 220);
        var side = k % 2 ? 'right:' + (-w * 0.25).toFixed(0) + 'px' : 'left:' + (-w * 0.25).toFixed(0) + 'px';
        html += '<div class="mk-coral" style="top:' + (yy - w).toFixed(0) + 'px;' + side + ';width:' + w.toFixed(0) + 'px;animation-duration:' + (5 + (k % 3)) + 's">' + coralSVG(k % 3, hues[k % hues.length]) + '</div>';
      }

      /* bąbelki */
      for (var b = 0; b < (mobile ? 14 : 26); b++) {
        var by = start + Math.random() * (H - start);
        html += '<span class="mk-bubble" style="top:' + by.toFixed(0) + 'px;left:' + (Math.random() * 100).toFixed(1) + '%;--b:' + (6 + Math.random() * 14).toFixed(0) + 'px;--t:' + (7 + Math.random() * 7).toFixed(1) + 's;--d:' + (-Math.random() * 10).toFixed(1) + 's"></span>';
      }
      box.innerHTML = html;
    }
    build();
    var last = document.documentElement.scrollHeight, t;
    function maybe() {
      var h = document.documentElement.scrollHeight;
      if (Math.abs(h - last) > 300) { last = h; build(); }
    }
    window.addEventListener('load', maybe);
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { mobile = window.innerWidth < 750; last = 0; maybe(); }, 300); });
    setTimeout(maybe, 2500);
  }

  /* ---------- Pojawianie się elementów ---------- */
  function reveal() {
    var els = document.querySelectorAll('[data-bb-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Baner: zdjęcie lekko podąża za myszką ---------- */
  function tilt() {
    if (reduce) return;
    document.querySelectorAll('[data-bb-tilt]').forEach(function (wrap) {
      var img = wrap.querySelector('.bb-hero__product');
      if (!img) return;
      var pending = false, ex = 0, ey = 0;
      wrap.addEventListener('mousemove', function (e) {
        ex = e.clientX; ey = e.clientY;
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var r = wrap.getBoundingClientRect();
          var x = (ex - r.left) / r.width - 0.5;
          var y = (ey - r.top) / r.height - 0.5;
          img.style.transform = 'translate3d(' + (x * 18) + 'px,' + (y * 14) + 'px,0) rotate(' + (x * 3) + 'deg)';
        });
      });
      wrap.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });
  }


  /* ---------- Liczniki (count-up) ---------- */
  function counters() {
    var els = document.querySelectorAll('[data-bb-count]:not([data-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-done', '1');
      var to = parseFloat(el.getAttribute('data-bb-count')) || 0, t0 = null;
      if (reduce) { el.textContent = to; return; }
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / 1400, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Przycisk „Zamów” w sekcjach strony produktu → do przycisku kupna ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bb-totop]');
    if (!a) return;
    var buy = document.querySelector('.product-form__submit, .product__info-wrapper');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Prezenty do zestawów 8 i 10 kolorów ----------
     Przy dodaniu zestawu do koszyka dokładamy produkty-prezenty (za 0 zł dzięki rabatom
     automatycznym w Shopify). Gdy klient usunie zestaw, prezenty też znikają. */
  var GIFTS = window.MK_GIFTS || {};
  var GIFT_PROP = 'Prezent';
  function giftItems(mainId, qty) {
    return (GIFTS[String(mainId)] || []).map(function (id) {
      return { id: id, quantity: qty, properties: { Prezent: 'GRATIS do zestawu' } };
    });
  }
  function isCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function isCartChange(url) { return /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url); }
  var origFetch = window.fetch;
  if (origFetch && Object.keys(GIFTS).length) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      try {
        if (isCartAdd(url) && init && init.body) {
          if (init.body instanceof FormData) {
            var fd = init.body, items = [], rest = [];
            fd.forEach(function (v, k) {
              var m = k.match(/^items\[(\d+)\]\[(\w+)\](.*)$/);
              if (m) { (items[+m[1]] = items[+m[1]] || { properties: {} }); if (m[2] === 'properties') items[+m[1]].properties[m[3].replace(/^\[|\]$/g, '')] = v; else items[+m[1]][m[2]] = v; }
              else rest.push([k, v]);
            });
            var single = fd.get('id');
            if (single && !items.length) {
              var it = { id: single, quantity: fd.get('quantity') || 1, properties: {} };
              rest = rest.filter(function (p) {
                var pm = p[0].match(/^properties\[(.*)\]$/);
                if (pm) { it.properties[pm[1]] = p[1]; return false; }
                return p[0] !== 'id' && p[0] !== 'quantity';
              });
              items = [it];
            }
            var extra = [];
            items.forEach(function (it) { if (it) extra = extra.concat(giftItems(it.id, it.quantity || 1)); });
            if (extra.length) {
              var nf = new FormData();
              rest.forEach(function (p) { nf.append(p[0], p[1]); });
              items.filter(Boolean).concat(extra).forEach(function (it, i) {
                nf.append('items[' + i + '][id]', it.id);
                nf.append('items[' + i + '][quantity]', it.quantity || 1);
                Object.keys(it.properties || {}).forEach(function (pk) { nf.append('items[' + i + '][properties][' + pk + ']', it.properties[pk]); });
              });
              init = Object.assign({}, init, { body: nf });
            }
          } else if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
            var data = JSON.parse(init.body);
            var list = data.items || (data.id ? [{ id: data.id, quantity: data.quantity || 1, properties: data.properties }] : []);
            var add = [];
            list.forEach(function (it) { add = add.concat(giftItems(it.id, it.quantity || 1)); });
            if (add.length) {
              delete data.id; delete data.quantity; delete data.properties;
              data.items = list.concat(add);
              init = Object.assign({}, init, { body: JSON.stringify(data) });
            }
          }
        }
      } catch (err) { /* w razie błędu zostaw zwykłe dodanie do koszyka */ }
      var res = origFetch.call(this, input, init);
      if (isCartChange(url)) res.then(function () { setTimeout(cleanGifts, 50); });
      return res;
    };
  }
  /* usuń prezenty, jeśli w koszyku nie ma już zestawu, do którego należą */
  function cleanGifts() {
    origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var allowed = {};
      cart.items.forEach(function (it) {
        (GIFTS[String(it.variant_id)] || []).forEach(function (g) { allowed[g] = (allowed[g] || 0) + it.quantity; });
      });
      var updates = {}, need = false;
      cart.items.forEach(function (it) {
        if (!it.properties || !it.properties[GIFT_PROP]) return;
        var max = allowed[it.variant_id] || 0;
        var q = Math.min(it.quantity, max);
        allowed[it.variant_id] = max - q;
        if (q !== it.quantity) { updates[it.key] = q; need = true; }
      });
      if (!need) return;
      origFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { location.reload(); });
    }).catch(function () {});
  }

  function init() { document.documentElement.classList.add('bb-js'); reveal(); tilt(); counters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { reveal(); tilt(); counters(); });
})();
